import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import { processesApi } from "api/TenantSlug/Processes/api";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import GetCascadeLogRequest = App.Http.Requests.Cascade.GetCascadeLogRequest;
import GetCascadeLogResponse = App.Http.Responses.Cascade.GetCascadeLogResponse;
import GetCascadeLogsRequest = App.Http.Requests.Cascade.GetCascadeLogsRequest;
import GetCascadeLogsResponse = App.Http.Responses.Cascade.GetCascadeLogsResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

export const useGetCascadeLogsQuery = (request: GetCascadeLogsRequest, options = {}) => {
    return useQueryApi<GetCascadeLogsResponse>({
        queryKey: ["getCascadeLogs", request],
        queryFn: () => processesApi.getLogs(request),
        ...options,
    });
};

export const useGetCascadeLogQuery = (logId: string, request?: GetCascadeLogRequest, options = {}) => {
    return useQueryApi<GetCascadeLogResponse>({
        queryKey: ["getCascadeLog", logId, request],
        queryFn: () => processesApi.getLog(logId, request),
        ...options,
    });
};

export const useGetCascadeLogsExportMutation = (
    options: UseMutationOptions<ExportResponse, AxiosError<ApiErrorResponse>, BaseExportRequest> = {}
) => {
    return useMutationApi<ExportResponse, BaseExportRequest>({
        mutationKey: ["getCascadeLogsExport"],
        mutationFn: (request) => processesApi.exportLogs(request),
        ...options,
    });
};
